import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    HsCode,
} from 'app/Apps/OrderManagement/ProformaInvoices/HsCode/HsCode.types'

export default (): DTOCardFormField<keyof HsCode>[] => {
    return [{
        title: 'General',
        fields: [
            {
                id: 'column1',
                fields: [{
                    name: 'country',
                    labelKey: 'HsCode.countryName',
                    componentName: 'CountryDataSelector',
                    disabled: true,
                }],
            },
            {
                id: 'column2',
                fields: [{
                    name: 'code',
                    labelKey: 'HsCode.code',
                    componentName: 'InputSingleline',
                    required: true,
                }],
            },
        ],
    }]
}
